module.exports = __webpack_public_path__ + "assets/img/open_1.df6e5d0e.png";